export const getRankImage = (rankName?: string) => {
  const name = rankName
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

  switch (name) {
    case "aprendiz elite":
      return "/images/rank/01.png";

    case "constructor":
      return "/images/rank/02.png";

    case "master":
    case "máster":
      return "/images/rank/03.png";

    case "esmeralda":
      return "/images/rank/04.png";

    case "diamante":
      return "/images/rank/05.png";

    case "diamante embajador":
      return "/images/rank/06.png";

    case "diamante embajador estrella":
    case "diamante embajador estrella 🌟":
      return "/images/rank/07.png";

    default:
      return "/images/rank/01.png";
  }
};